import React, { FunctionComponent } from "react";
import styles from "./Logo.module.scss";
import LogoProps from "./LogoProps.interface";

import Anchor from "components/Anchor/Anchor";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import combineClasses from "helpers/combine-classes";

const Logo: FunctionComponent<LogoProps> = (props): JSX.Element => {
    const imageAspectRatio = getImageAspectRatio(undefined, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);

    const link = props.content.links?.[0] && props.content.links.length > 0 ? props.content.links[0].content.link : undefined;

    const logoSizeClass = props.settings.logoSize ? styles[props.settings.logoSize] : undefined;

    return (
        <div className={combineClasses(styles.wrapper, logoSizeClass)}>
            <Anchor className={styles.link} to={link}>
                {/* Image */}
                {props.content.image ? (
                    <ImageViewer className={styles.image} src={props.content.image.umbracoFile.src} type="contain" extensionType="png" alt={props.content.imageAlternative} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                ) : null}
            </Anchor>

            {props.settings.cardBackgroundMedia?.[0] && props.settings.cardBackgroundMedia.length > 0 ? (
                <BackgroundMedia className={styles.background} key={`primary_${props.content.image.umbracoFile.src}`} {...props.settings.cardBackgroundMedia[0]} />
            ) : null}

            {props.settings.cardHoverBackgroundMedia?.[0] && props.settings.cardHoverBackgroundMedia.length > 0 ? (
                <BackgroundMedia className={styles.hover_background} key={`hover_${props.content.image.umbracoFile.src}`} {...props.settings.cardHoverBackgroundMedia[0]} />
            ) : null}
        </div>
    );
};

export default Logo;